import React, { forwardRef } from "react";

const MemberItem = React.forwardRef(
  (
    {
      sessionRoom,
      name,
      mobileBlockChange,
      controllerName,
      currentUserType,
      index,
      ...props
    },
    ref
  ) => (
    <li ref={ref} {...props}>
      <a
        className={`session-room-show-info clearfix ${
          sessionRoom.attributes.unread == 0 ? "" : "unread"
        }`}
        id={`session_room_${sessionRoom.id}`}
        data-type="html"
        data-session-room-id={sessionRoom.id}
        data-remote="true"
        href={
          controllerName == "coaching_plans"
            ? `/chats/${sessionRoom.id}/development_plans`
            : `/chats/${sessionRoom.id}`
        }
      >
        <div className="sort">
          <i className="fa browser-view-icon fa-reorder"></i>
        </div>
        <div className="avatar">
          <img
            src={
              currentUserType == "coach"
                ? sessionRoom.links.student_avatar
                : sessionRoom.links.coach_avatar
            }
            className="img-circle"
            height="40px"
          />
        </div>
        <div className="title">
          {currentUserType == "coach"
            ? sessionRoom.attributes.student
            : sessionRoom.attributes.coach}
        </div>
        <div className="count">
          <span>{sessionRoom.attributes.unread}</span>
        </div>
      </a>
      <div className="action text-right">
        <div
          onClick={(e) => mobileBlockChange(index, name, sessionRoom.id)}
          className="btn btn-sm btn-green"
        >
          {name == "memberListActive" ? "Archive" : "Return to Active List"}
        </div>
      </div>
    </li>
  )
);

export default MemberItem;
